import React, { createContext, useContext, useState } from "react";

type LearningContextType = {
  learningUpdated: number;
  triggerLearningUpdate: () => void;
};

const LearningContext = createContext<LearningContextType | undefined>(
  undefined
);

export const LearningProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [learningUpdated, setLearningUpdated] = useState<number>(0);

  const triggerLearningUpdate = () => {
    setLearningUpdated((prev) => prev + 1);
  };

  return (
    <LearningContext.Provider
      value={{ learningUpdated, triggerLearningUpdate }}
    >
      {children}
    </LearningContext.Provider>
  );
};

export const useLearning = () => {
  const context = useContext(LearningContext);
  if (context === undefined) {
    throw new Error("useLearning must be used within a LearningProvider");
  }
  return context;
};
